import { FinancingCompany } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export interface FinancingCompaniesState {
    financingCompanies: FinancingCompany[] | undefined;
    loaded: boolean;
    loading: boolean;
    error: AppError | null;
}

export const initialFinancingCompaniesState: FinancingCompaniesState = {
    financingCompanies: undefined,
    loaded: false,
    loading: false,
    error: null,
};
